const CARE_DASHBOARD = "caredashboard";
const COMPANY_INFO = "companyinfo";
const COMPANY_SETUP = "company-setup";
const PLAN_SELECTION = "companyinfo/select-plan";
const BUILD_PLAN = "buildyourplan";
const UPLOAD_EXCEL = "uploadexcel";
const ROOT = "";
const PAYMENTSUMMARY = "paymentsummary";
const UPLOAD_CDEXCEL = "uploadCdExcel";
const UPLOAD_POLICYNOS = "uploadPolicyNos";
const GMC_PAYMENTSUMMARY = "gmcPaymentSummary";
const ENDORSEMENT_EDIT = "endorsement_edit";
const UPLOADPOLICYDOC = "upload_policy_document";
const UPLOAD_RATECHART = "uploadratechart";
const RATE_CHART = "ratechart";
const UPLOAD_DOCUMENT = "uploadDocument";
const PREPURCHASE_RECOMMENDATION = "pre_purchase_recommendation";
const ADD_DELETE_EMPLOYEE = "addDeleteEmoployee";
const THANKYOU_PAGE = "thankYoupage";
const THANKYOU_PAGE_MESSAGE = "thank_you";
const MANAGER_DASHBOARD = "managerDashBoard";
const SIGNUP = "signUp";
const FORGET_PASSWORD = "forgetpassword";
const INSURANCE_SETUP = "insurance_setup";
const GMC_SETUP = "ghi_setup";
const VIEW_CD_BALANCE = "view_cd_balance";
const VIEW_CD_TBALE = "view_cd_transaction";
const GPA_SETUP = "plan_setup/gpa";
const GTL_SETUP = "plan_setup/gtl";
const GMC_RATECHART = "tpa-setup/gmc";
const SELECT_PLAN = "select_plan";
const E_CARD_PREVIEW = "e-card-preview";
const E_CARD_DOWNLOAD = "e-card-preview/download";
const GHI_TPA_SETUP = "setup/ghi-tpa";

// FLEX ROUTES
const FLEX_BENEFITS_SETUP = "flex/setup/benefits";
const FLEX_TPA_SETUP = "flex/setup/tpa";
const FLEX_GPA_SETUP = "flex/setup/gpa";
const FLEX_PRICING_SETUP = "flex/setup/ghi";
const FLEX_ATTRIBUTE_SETUP = "flex/setup/attributes";
const FLEX_UPLOAD_DOCUMENTS = "flex/setup/upload-documents";

const FLEX_DASHBOARD = "flex/dashboard";
const FLEX_MASTER_DOC = "flex/setup/master";
const FLEX_EMP_UPLOAD = "flex/employee-sheet-upload";
const FLEX_ERROR_FILE = "flex/error-file";
const FLEX_PENDING_STATE = "flex/pending-status";
const FLEX_PRODUCT_STATUS = "flex/product-status";
const FLEX_PRODUCT_UPLOAD = "flex/bulk-product-upload";
const ENROLMENT_HISTORY = "flex/enrolment-history";
const GRADE_SETUP = "grade-setup";

//corporate buffer
const PRE_CORPORATE_BUFFER = "corporate_buffer";

//universal setup
const UNIVERSAL_BENEFITS_SETUP = "benefits";
const UNIVERSAL_PLAN_SETUP = "plan-setup";
const UNIVERSAL_COVERAGE_DOC = "plan-setup/coverage";
const UNIVERSAL_INSURER_SETUP = "plan-setup/insurer";
const UNIVERSAL_TPA = "plan-setup/tpa";

//upload policy id
const UNIVERSAL_PRODUCT_SELECT_UHID = "select-product";
const UNIVERSAL_POLICY_ID_UPLOAD = "policy-id-upload";
const UNIVERSAL_SUPER_TASK = "super-task-reupload";

//universal postissuanve
const UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID = "upload-uhid";
const UPDATE_CORPORATE_BUFFER = "update-corporate-buffer";
const VIEW_CORPORATE_BUFFER = "view-corporate-buffer";

//universal data collection
const EMPLOYEE_DATA_COLLECTION = "upload-employee-data";
const EMPLPLOYEE_DATA_COLLECTION_HISTORY = "data-collection-history";

//claim support
const CLAIM_SUPPORT = "claim-support";
const POST_ISSUANCE_PENDING_STATUS = "pending-status";
const POST_ISSUANCE_DOWNLOAD_ERROR_FILE = "download-error-file";

//user profile
const USER_PROFILE = "user-profile";
const CHANGE_PASSWORD = "change-password";

// Utilities
const UTILITIES = "utlities";
const UTILITIES_UHID_GENERATOR = "utlities/uhid-generator";
//claim dashboard
const CLAIM_DASHBOARD = "claim-dashboard"
const CLAIMS_SUMMARY_MIS = "claims-summary/mis";
const CLAIMS_SUMMARY_MIS_EMPLOYEE = "claims-summary/mis/:employee_number";

export default {
  CARE_DASHBOARD,
  COMPANY_INFO,
  COMPANY_SETUP,
  PLAN_SELECTION,
  BUILD_PLAN,
  UPLOAD_EXCEL,
  ROOT,
  PAYMENTSUMMARY,
  UPLOAD_CDEXCEL,
  UPLOAD_POLICYNOS,
  UPLOADPOLICYDOC,
  UPLOAD_RATECHART,
  RATE_CHART,
  UPLOAD_DOCUMENT,
  PREPURCHASE_RECOMMENDATION,
  ADD_DELETE_EMPLOYEE,
  THANKYOU_PAGE,
  THANKYOU_PAGE_MESSAGE,
  GMC_PAYMENTSUMMARY,
  MANAGER_DASHBOARD,
  SIGNUP,
  FORGET_PASSWORD,
  ENDORSEMENT_EDIT,
  INSURANCE_SETUP,
  GMC_SETUP,
  VIEW_CD_BALANCE,
  VIEW_CD_TBALE,
  GPA_SETUP,
  GTL_SETUP,
  GMC_RATECHART,
  SELECT_PLAN,
  E_CARD_PREVIEW,
  E_CARD_DOWNLOAD,
  FLEX_BENEFITS_SETUP,
  FLEX_TPA_SETUP,
  FLEX_GPA_SETUP,
  FLEX_PRICING_SETUP,
  FLEX_UPLOAD_DOCUMENTS,
  FLEX_DASHBOARD,
  FLEX_MASTER_DOC,
  FLEX_EMP_UPLOAD,
  GHI_TPA_SETUP,
  FLEX_ERROR_FILE,
  FLEX_PRODUCT_STATUS,
  FLEX_PRODUCT_UPLOAD,
  FLEX_PENDING_STATE,
  ENROLMENT_HISTORY,
  FLEX_ATTRIBUTE_SETUP,
  GRADE_SETUP,
  PRE_CORPORATE_BUFFER,
  UNIVERSAL_BENEFITS_SETUP,
  UNIVERSAL_PLAN_SETUP,
  UNIVERSAL_POLICY_ID_UPLOAD,
  UNIVERSAL_PRODUCT_SELECT_UHID,
  UNIVERSAL_INSURER_SETUP,
  UNIVERSAL_COVERAGE_DOC,
  UNIVERSAL_SUPER_TASK,
  UNIVERSAL_TPA,
  UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID,
  UPDATE_CORPORATE_BUFFER,
  VIEW_CORPORATE_BUFFER,
  EMPLOYEE_DATA_COLLECTION,
  EMPLPLOYEE_DATA_COLLECTION_HISTORY,
  CLAIM_SUPPORT,
  POST_ISSUANCE_PENDING_STATUS,
  POST_ISSUANCE_DOWNLOAD_ERROR_FILE,
  USER_PROFILE,
  CHANGE_PASSWORD,
  UTILITIES,
  UTILITIES_UHID_GENERATOR,
  CLAIM_DASHBOARD,
  CLAIMS_SUMMARY_MIS,
  CLAIMS_SUMMARY_MIS_EMPLOYEE
};
